module.exports = __webpack_public_path__ + "img/sentida_5.0ce9c4b9.png";